import { fetchGet } from '../fetch';
export const availableLanguages = (signal) => {
    return fetchGet('available-languages', {}, signal);
};
//# sourceMappingURL=available-languages.js.map